import React, { useEffect, useState } from 'react';

import CustomerGroupSelector from './customer-group-selector';
import mocks from './mocks';
import translations from './translations';

translations.init();

type ConditionalCustomerGroupSelectorProps = {
  customerServiceUrl: string;
  environment: string;
};

const ConditionalCustomerGroupSelector = ({
  environment,
  ...props
}: ConditionalCustomerGroupSelectorProps) => {
  const [workerLoaded, setWorkerLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (environment !== 'development') {
      setWorkerLoaded(true);
      return;
    }
    mocks.browser.setup().finally(() => {
      setWorkerLoaded(true);
    });
  }, []);

  if (!workerLoaded) {
    return null;
  }

  return <CustomerGroupSelector {...props} />;
};

export default ConditionalCustomerGroupSelector;
